import { getAPIBaseUrl } from './parcelHandler.js';

export async function postLotteryParticipation({ parcelID, shippingNumber, phoneNumber, email, marketingConsent, marketingConsentDate }) {
    const baseUrl = getAPIBaseUrl('v1', 'customer', 'public');
    const url = `${baseUrl}/lottery`;

    const body = { parcelID, shippingNumber, phoneNumber, email };
    if (marketingConsent) {
        body.marketingConsent = true;
        body.marketingConsentDate = marketingConsentDate;
    }

    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(body),
        });
        const data = await response.json();
        return { ...data, status: response.status };
    } catch (error) {
        if (process.env.REACT_APP_DEBUG === 'true') {
            console.error('Error postLotteryParticipation:', error);
        }
        return { status: 500, results: 'Network error' };
    }
}
